/**
 * AuthGate -- Route wrapper that redirects unauthenticated users to /login.
 *
 * Wraps protected route groups (e.g., AppLayout module routes) so that only
 * authenticated users can access them. Unauthenticated users are sent to
 * /login (the dedicated sign-in page introduced alongside PlatformLayout).
 */

import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/lib/auth'
import { LoadingSpinner } from '@/shared/components/feedback/LoadingSpinner'

export function AuthGate() {
  const { isLoading, isLoggedIn } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-ue-bg-darkest">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
